import React, { useEffect } from "react";
import ActionOnApplication from "../ActionOnApplication";
import { useDispatch, useSelector } from "react-redux";
import { GetComponentRoundByFlowAndGUID } from "../../../Redux/Reducers/Manager/FlowComponent";
import { GetFlowActionByTaskId } from "../../../Redux/Reducers/Manager/FlowAction";

function ActionViewPopUp(props) {
  const dispatch = useDispatch();
  // const [componentFlow,setComponentFlow]=useState([])
  const recommendation = useSelector(
    (state) => state.FlowActionByTaskId.FlowActionByTaskId
  );
  const ComponentRoundByFlow_ = useSelector(
    (state) => state.FlowComponent?.FlowComponentByFlowAndGUID
  );

  useEffect(() => {
    dispatch(
      GetComponentRoundByFlowAndGUID({
        flowId: props.flowGuid,
      })
    );
  }, [props.flowGuid]);


let componentFlow = [];
  if(ComponentRoundByFlow_?.length> 0){
  componentFlow= ComponentRoundByFlow_?.map(
    (ele) => ele?.componentId
  )

  }


  useEffect(() => {
    dispatch(
      GetFlowActionByTaskId({
        mainTaskId: props.taskId,
        subTaskId: null,
      })
    );
  }, [props.taskId]);
  return (
    <>
      {recommendation ? (
        <>
          <ActionOnApplication
            disabled={true}
            Recommendation={componentFlow?.includes(
              "364d0cb4-1e77-4f7b-9bf6-c5c77e74fd2d"
            )}
            // setAttachment={setAttachment}
            Attachment={componentFlow?.includes(
              "4f90a961-372a-4973-8043-65fb7c3e2d58"
            )}
            Reason={componentFlow?.includes(
              "c5f49e37-997b-4bef-a8df-571791dc6d6a"
            )}
            AdditionalNotes={componentFlow?.includes(
              "0bed9655-e693-4493-bc43-1363b9f99304"
            )}
            FlowActionSpecificRow={recommendation}
            ReasonValue={recommendation?.actionReason}
            AdditionalNotesData={recommendation?.additionalNote}
            CVDocumentAttachment={recommendation?.actionAttacment}
           
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default ActionViewPopUp;
